// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1fQSz","topBottomGutter":"Layout_topBottomGutter__2YGWI"};